import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { InvestmentsSimulationEventType } from '../investments-simulation.event.type';
import { CurrentBalanceEventType } from '../../../../shared/current-balance/current-balance.event.type';
import { Simulation } from '../../models/simulation';

@Component({
	selector: 'app-investments-result',
	templateUrl: './investments-result.component.html',
	styleUrls: ['./investments-result.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestmentsResultComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() simulationData: Simulation;

	@Output() setTitleSubtitle: EventEmitter<any> = new EventEmitter<any>();

	private view = '[data-component="investments-result"]';

	active = false;

	constructor() {
	}

	ngOnInit() {
		AppEventDispatcher.listen(InvestmentsSimulationEventType.STEPS.INVESTMENTS_SUMMARY, data => {

			if (data.show) {
				this.active = true;
				this.show();
			} else {
				this.hide();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(InvestmentsSimulationEventType.STEPS.INVESTMENTS_SUMMARY);
	}

	show() {
		this.setTitleSubtitle.emit({
			title: 'Resumo de Investimentos',
			subtitle: 'Simule e contrate o melhor investimento para você',
		});

		AppEventDispatcher.dispatch(InvestmentsSimulationEventType.ACTIONS.BUTTONS, { show: false });

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
			AppEventDispatcher.dispatch( CurrentBalanceEventType.BALANCE_UPDATE, null);
		});
	}

	hide() {
		TweenMax.to(this.view, .8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-simulation/investments-result/investments-result.component.ts